export const NUM_CRITICAL_PATHS = 5;
// numPaths=0 asks the scheduler for every float path rather than the capped top-5. Used when organize-by
// Float Path needs all levels; the caller then trims to NUM_CRITICAL_PATHS for the widget. See PRD-27573.
export const ALL_CRITICAL_PATHS = 0;
export const CP_LEVEL = 1; // 1 is CP, 2 is FP2, 3 is FP3 and so on
export enum CRITICAL_PATH_LEVELS {
  CRITICAL_PATH = 1,
  FLOAT_PATH_2 = 2,
  FLOAT_PATH_3 = 3,
  FLOAT_PATH_4 = 4,
  FLOAT_PATH_5 = 5
}
